// extracted by mini-css-extract-plugin
export var headerContainer = "header-module--headerContainer--kY2F-";
export var logo = "header-module--logo--bLO3n";
export var navBarBtnContainer = "header-module--navBarBtnContainer--b8zAr";
export var navBarExpand = "header-module--navBarExpand--VDM+A";
export var partOfHistory = "header-module--partOfHistory--+Mhjt";